import type { GetToolbarSettings } from './../ricos-types';
import { TOOLBARS } from './../editor-common';

const defaultShouldCreate = {
  desktop: false,
  mobile: {
    android: false,
    ios: false,
  },
};

export const getDefaultToolbarSettings: GetToolbarSettings = ({ pluginButtons }) => {
  return [
    {
      name: TOOLBARS.QUICK_ACTIONS,
      shouldCreate: () => ({ ...defaultShouldCreate, desktop: true }),
      activateOnFloatingPlusButton: false,
    },
    //TODO: check if needed
    {
      name: TOOLBARS.INSERT_PLUGIN,
      shouldCreate: () => defaultShouldCreate,
    },
    //TODO: check if needed
    {
      name: TOOLBARS.FORMATTING,
      shouldCreate: () => defaultShouldCreate,
    },
    {
      name: TOOLBARS.SIDE,
      shouldCreate: () => {
        const shouldCreate =
          pluginButtons &&
          pluginButtons.filter(({ buttonSettings }) =>
            buttonSettings.toolbars?.includes(TOOLBARS.SIDE)
          ).length > 0;
        return {
          desktop: shouldCreate,
          mobile: {
            ios: shouldCreate,
            android: shouldCreate,
          },
        };
      },
    },
    {
      name: TOOLBARS.MOBILE,
      shouldCreate: () => ({
        desktop: false,
        mobile: {
          ios: true,
          android: true,
        },
      }),
    },
    {
      name: TOOLBARS.FOOTER,
      shouldCreate: () => ({
        desktop:
          pluginButtons &&
          pluginButtons.filter(({ buttonSettings }) =>
            buttonSettings.toolbars?.includes(TOOLBARS.FOOTER)
          ).length > 0,
        mobile: {
          ios: false,
          android: false,
        },
      }),
    },
    {
      name: TOOLBARS.STATIC,
      shouldCreate: () => ({
        desktop: true,
        mobile: {
          ios: true,
          android: false,
        },
      }),
    },
    {
      name: TOOLBARS.INLINE,
      shouldCreate: () => ({
        desktop: true,
        mobile: {
          ios: false,
          android: false,
        },
      }),
    },
    {
      name: TOOLBARS.PLUGIN,
      shouldCreate: () => {
        const shouldCreate = pluginButtons && pluginButtons.length > 0;
        return {
          desktop: shouldCreate,
          mobile: {
            ios: shouldCreate,
            android: shouldCreate,
          },
        };
      },
    },
    {
      name: TOOLBARS.LINK,
      shouldCreate: () => {
        return {
          desktop: true,
          mobile: {
            ios: true,
            android: true,
          },
        };
      },
    },
  ];
};
